import { createContext, type Dispatch } from 'react';
import { type CompanyTheme } from '../../../api/types';

export type ThemeOverride = {
    // custom font
    font?: string;

    // custom font bold
    fontBold?: string;

    // UID
    id: string;

    // primary color
    primaryColor: string;

    theme: CompanyTheme;
};

export type Action =
    | { type: 'register'; override: ThemeOverride }
    | { type: 'update'; override: ThemeOverride }
    | { type: 'unregister'; id: string };

export const ThemeControllerContext = createContext<Dispatch<Action> | null>(null);
